import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { block } from '../../utils/block.js';
import './Checkbox.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const _excluded = ["children", "onClick", "checked", "className", "position", "disabled", "icon", "id", "checkboxPosition", "withInputCheckbox"];
const b = block('checkbox');
const Checkbox = _ref => {
  let {
      children,
      onClick,
      checked,
      className = '',
      position,
      disabled = false,
      icon,
      id,
      checkboxPosition = 'top',
      withInputCheckbox
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const onKeyPress = _ref2 => {
    let {
      code
    } = _ref2;
    if (code === 'Space') {
      onClick();
    }
  };
  return /*#__PURE__*/jsxs("div", _objectSpread2(_objectSpread2({
    className: b({
      checked,
      position,
      disabled
    }).mix(className),
    onClick: onClick,
    "aria-disabled": disabled,
    tabIndex: 0,
    onKeyPress: onKeyPress
  }, rest), {}, {
    children: [withInputCheckbox && /*#__PURE__*/jsx("div", {
      className: b('toggle', {
        position: checkboxPosition
      }),
      children: /*#__PURE__*/jsx("input", {
        className: b('input'),
        type: "checkbox",
        disabled: disabled,
        id: id,
        "aria-hidden": true,
        tabIndex: -1
      })
    }), /*#__PURE__*/jsxs("label", {
      className: b('content'),
      htmlFor: id,
      children: [children, icon && /*#__PURE__*/jsx("span", {
        className: b('icon'),
        children: icon
      })]
    })]
  }));
};

export { Checkbox };
